'use client';
import React, { useEffect, useState } from 'react';
import { createClient } from '@/lib/supabase/client';

export default function DashboardHeader() {
  const [userName, setUserName] = useState('');
  const supabase = createClient();

  useEffect(() => {
    supabase?.auth?.getSession()?.then(async ({ data: { session } }) => {
      if (session?.user) {
        const { data } = await supabase?.from('user_profiles')?.select('full_name')?.eq('id', session?.user?.id)?.single();
        if (data?.full_name) {
          setUserName(data?.full_name?.split(' ')?.[0]);
        }
      }
    });
  }, []);

  return (
    <div className="flex items-start justify-between gap-4 flex-wrap">
      <div>
        <h1 className="text-2xl font-800 text-gray-900">Dashboard</h1>
        <p className="text-sm text-gray-500 mt-1">
          Selamat datang kembali, {userName || 'Admin'} 👋
        </p>
      </div>
    </div>
  );
}
